import React from 'react';
import { TrendingUp, ArrowUp, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

export const StatCard = ({ icon: Icon, label, value, growth, sub, iconBg = 'bg-orange-50', iconColor = 'text-orange-500', progress }) => (
  <div className="bg-white rounded-xl p-4 card-shadow card-hover border border-gray-100 animate-fade-up">
    <div className="flex items-start justify-between mb-2.5">
      <div className={`w-9 h-9 rounded-lg ${iconBg} flex items-center justify-center`}>
        <Icon className={`w-4.5 h-4.5 ${iconColor}`} strokeWidth={2.2} />
      </div>
      {progress !== undefined && (
        <div className="relative w-10 h-10">
          <svg className="w-10 h-10 -rotate-90">
            <circle cx="20" cy="20" r="16" stroke="#FED7AA" strokeWidth="3.5" fill="none" />
            <circle
              cx="20" cy="20" r="16" stroke="#F97316" strokeWidth="3.5" fill="none"
              strokeDasharray={100.5}
              strokeDashoffset={100.5 - (100.5 * progress) / 100}
              strokeLinecap="round"
            />
          </svg>
          <span className="absolute inset-0 flex items-center justify-center text-[10px] font-bold text-orange-600">{progress}%</span>
        </div>
      )}
    </div>
    <p className="text-xs font-semibold text-gray-500">{label}</p>
    <h3 className="text-xl sm:text-2xl font-black text-gray-900 mt-0.5">{value}</h3>
    {growth !== undefined && (
      <div className="flex items-center gap-1 mt-1.5 text-xs font-bold text-emerald-600">
        <ArrowUp className="w-3 h-3" />
        <span>{growth}%</span>
        <span className="text-gray-400 font-medium ml-1">dari bulan lalu</span>
      </div>
    )}
    {sub && <p className="text-[11px] text-gray-400 font-medium mt-1.5">{sub}</p>}
  </div>
);

export const SectionCard = ({ title, action, children, className = '' }) => (
  <div className={`bg-white rounded-xl p-4 sm:p-5 card-shadow border border-gray-100 ${className}`}>
    <div className="flex items-center justify-between mb-3.5 flex-wrap gap-2">
      <h3 className="text-xs font-bold tracking-wide text-gray-900 uppercase">{title}</h3>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
    {children}
  </div>
);

export const formatNumber = (n) => new Intl.NumberFormat('id-ID').format(n);

export const Pager = ({ page, pages, total, limit, onPageChange }) => {
  if (!total) return null;
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);
  return (
    <div className="flex items-center justify-between flex-wrap gap-2.5 mt-3 pt-3 border-t border-gray-100">
      <p className="text-[11px] text-gray-500 font-medium">
        Menampilkan {formatNumber(start)}-{formatNumber(end)} dari {formatNumber(total)} data
      </p>
      <div className="flex items-center gap-1.5">
        <Button variant="outline" size="sm" className="h-7.5 px-2.5 text-xs gap-1" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          <ChevronLeft className="w-3.5 h-3.5" /> Sebelumnya
        </Button>
        <span className="text-xs font-bold text-gray-700 px-1">Halaman {page} dari {pages}</span>
        <Button variant="outline" size="sm" className="h-7.5 px-2.5 text-xs gap-1" disabled={page >= pages} onClick={() => onPageChange(page + 1)}>
          Berikutnya <ChevronRight className="w-3.5 h-3.5" />
        </Button>
      </div>
    </div>
  );
};
